
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.464 0C14.176 0 16 1.904 16 4.728v6.536C16 14.096 14.176 16 11.464 16H4.528C1.817 16 0 14.096 0 11.264V4.728C0 1.904 1.817 0 4.528 0h6.936zM8 4.136c-.336 0-.6.264-.6.6v5.08L5.424 7.832A.614.614 0 005 7.656a.63.63 0 00-.424.176.604.604 0 000 .848l3 3.016a.619.619 0 00.848 0l3-3.016a.604.604 0 000-.848.613.613 0 00-.856 0L8.6 9.816v-5.08a.6.6 0 00-.6-.6z","fill":"#fff"}})])
          )
        }
      }
    